import { render } from "./AnimationPage.vue?vue&type=template&id=577fa640&scoped=true"
import script from "./AnimationPage.vue?vue&type=script&lang=js"
export * from "./AnimationPage.vue?vue&type=script&lang=js"

import "./AnimationPage.vue?vue&type=style&index=0&id=577fa640&scoped=true&lang=scss"

import exportComponent from "/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-577fa640"]])

export default __exports__